import { useState } from 'react';
import { oneOfType, string } from 'prop-types';
import { Button, Divider } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Trans } from '@lingui/macro';

import messageDescriptor from '../../lingui/LinguiPropTypes';
import Actions from '../actions/Actions';
import PanBackAction from '../actions/PanBackAction';
import PanForwardAction from '../actions/PanForwardAction';
import ResetAction from '../actions/ResetAction';
import ZoomInAction from '../actions/ZoomInAction';
import ZoomOutAction from '../actions/ZoomOutAction';
import ReportAction, { reportActionOptionsType } from '../actions/ReportAction';
import EditDashboardAction from '../actions/EditDashboardAction';
import DeleteDashboardAction from '../actions/DeleteDashboardAction';
import { useDashboardContext } from './DashboardContext';
import { usePageId } from '../page/PageUtils';
import { ShareDashboardDialog } from './ShareDashboardDialog';

const useStyles = makeStyles((theme) => ({
    actionsContainer: {
        '& .MuiDivider-root': {
            marginLeft: 16,
            marginRight: 4,
        },
    },
    editActionsContainer: {
        marginLeft: theme.spacing(2),

        '& .MuiFormGroup-row': {
            flexWrap: 'nowrap',
        },

        '& .MuiFormControlLabel-label': {
            whiteSpace: 'nowrap',
        },
    },
}));

export default function DashboardActions({ pageTitle, reportActionOptions }) {
    const [shareDialogOpen, setShareDialogOpen] = useState(false);
    const styles = useStyles();
    const pageId = usePageId();
    const { dashboardActions, editing, editable, deletable, sharable, valid } = useDashboardContext();

    function handleCancel() {
        dashboardActions.setEditing(false);
    }

    function handleSave() {
        dashboardActions.save();
    }

    if (editing) {
        return (
            <Actions className={styles.editActionsContainer}>
                <Button onClick={handleCancel}>
                    <Trans>Cancel</Trans>
                </Button>
                <Button color="primary" variant="contained" disabled={!valid} onClick={handleSave}>
                    <Trans>Save</Trans>
                </Button>
            </Actions>
        );
    }

    return (
        <>
            <Actions className={styles.actionsContainer}>
                {sharable && (
                    <>
                        <Button color="primary" variant="contained" onClick={() => setShareDialogOpen(true)}>
                            Share
                        </Button>
                        <Divider orientation="vertical" flexItem />
                    </>
                )}
                <PanBackAction tooltipPlacement="bottom" />
                <PanForwardAction tooltipPlacement="bottom" />
                <ZoomInAction tooltipPlacement="bottom" />
                <ZoomOutAction tooltipPlacement="bottom" />
                <ResetAction tooltipPlacement="bottom" />
                <ReportAction
                    pageId={pageId}
                    pageTitle={pageTitle}
                    options={reportActionOptions}
                    tooltipPlacement="bottom"
                />
                {editable && <EditDashboardAction tooltipPlacement="bottom" />}
                {deletable && <DeleteDashboardAction tooltipPlacement="bottom" />}
            </Actions>
            <ShareDashboardDialog open={shareDialogOpen} setOpen={setShareDialogOpen} />
        </>
    );
}

DashboardActions.propTypes = {
    pageTitle: oneOfType([messageDescriptor, string]),
    reportActionOptions: reportActionOptionsType,
};

DashboardActions.defaultProps = {
    pageTitle: undefined,
    reportActionOptions: undefined,
};
